export default function CategoryFilter({ setCategory }) {
  const categories = ["All", "Market", "Equity", "Crypto", "Forex", "Education", "Tools"];

  return (
    <div className="flex gap-3 overflow-x-auto py-3 px-2">
      {categories.map((c) => (
        <button
          key={c}
          onClick={() => setCategory(c)}
          className="px-4 py-1 bg-gray-800 text-white rounded-full text-sm"
        >
          {c}
        </button>
      ))}
    </div>
  );
}
